
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type alertOptions = ApiMethodBase & {
    message?: string;
    severity?: string;
    showAlert?: boolean;
    timeOutActive?: boolean;
    component?: string
}

export const alertMessage = ({
    message,
    severity,
    showAlert,
    timeOutActive,
    component,
    eventEmitter,
}: alertOptions) => {
    if (component === 'settings_visualizer') {eventEmitter.emit(Event.visualizerSettingsAlert, message, severity, showAlert, timeOutActive);}
    if (component === 'upload_file') {eventEmitter.emit(Event.uploadFileAlert, message, severity, showAlert, timeOutActive);}

    if (component === 'variantFilter') {eventEmitter.emit(Event.variantFilterAlert, message, severity, showAlert, timeOutActive);}
    if (component === 'stepFilter') {eventEmitter.emit(Event.stepFilterAlert, message, severity, showAlert, timeOutActive);}
    if (component === 'activityFilter') {eventEmitter.emit(Event.activityFilterAlert, message, severity, showAlert, timeOutActive);}
    if (component === 'pathFilter') {eventEmitter.emit(Event.pathFilterAlert, message, severity, showAlert, timeOutActive);}
    if (component === 'timeFilter') {eventEmitter.emit(Event.timeFilterAlert, message, severity, showAlert, timeOutActive);}
    if (component === 'attributeFilter') {eventEmitter.emit(Event.attributeFilterAlert, message, severity, showAlert, timeOutActive);}

    if (component === 'discoveryConstraint') {eventEmitter.emit(Event.attributeFilterAlert, message, severity, showAlert, timeOutActive);}
    if (component === 'taskConstraint') {eventEmitter.emit(Event.taskConstraintAlert, message, severity, showAlert, timeOutActive);}
};

